(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('aura-hero-video')) {
  customElements.define('aura-hero-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const initialize = () => {
        const video = this.querySelector('video');
        if (!video || !this.isConnected) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
        const schedule = () => {
          clearTimeout(this.playTimer);
          if (!this.pageReady || !this.inView) return;
          this.playTimer = setTimeout(() => {
            if (!this.isConnected || !this.inView) return;
            video.play().catch(() => {});
          }, 750);
        };
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          if (!this.inView) {
            clearTimeout(this.playTimer);
            video.pause();
          } else schedule();
        }, { threshold: 0.01 });
        this.observer.observe(video);
        const pageReady = () => { this.pageReady = true; schedule(); };
        if (document.readyState === 'complete') pageReady();
        else window.addEventListener('load', pageReady, { once: true, signal });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
      } else initialize();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      clearTimeout(this.playTimer);
      this.pageReady = false;
      this.inView = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
